import { render, staticRenderFns } from "./ViewInfoCard.vue?vue&type=template&id=8afdedba&"
import script from "./ViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./ViewInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports